import { useEffect, useState } from "react";
import { Loading } from "@/component/Loading";
import IC_BIND_SUCCESS from "@/assets/device/ic_bind_success.svg?react";
import IC_BIND_WARN from "@/assets/device/ic_bind_warn.svg?react";
import IC_BIND_ERROR from "@/assets/device/ic_bind_error.svg?react";
import { qrCodeAuth } from "@/services/device";

interface IBindInfo {
  title: string;
  content?: string[];
  icon: React.ReactNode;
}

export default function DeviceBind() {
  const [isLoading, setIsLoading] = useState(true);
  const [bindInfo, setBindInfo] = useState<IBindInfo>();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const qrCodeId = queryParams.get("qrCodeId") || "";
    handleBindDevice(qrCodeId);
  }, []);

  const handleBindDevice = async (qrCodeId: string) => {
    try {
      setIsLoading(true);
      await qrCodeAuth({ qrCodeId });
      setBindInfo({
        title: `授权关联成功`,
        content: [
          "请前往大屏继续操作",
        ],
        icon: <IC_BIND_SUCCESS />,
      });
      setIsLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("handleBindDevice error", error);
      setIsLoading(false);
      // 该账号关联设备已达上限
      if (error?.errorCode === 40009150) {
        setBindInfo({
          title: "该账号关联设备已达上限",
          icon: <IC_BIND_WARN />,
        });
      } else {
        setBindInfo({
          title: error?.errMsg || "授权失败",
          content: ['请前往大屏重新扫码'],
          icon: <IC_BIND_ERROR />,
        });
      }
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center relative">
      {isLoading ? (
        <div className="flex-1 flex flex-items-center flex-justify-center absolute top-50% left-50% translate-x--50% translate-y--50%">
          <Loading />
        </div>
      ) : (
        <div className="absolute top-33.33% flex items-center justify-center flex-col">
          {bindInfo?.icon}
          <div className="text-center mt-6 font-500 text-5 lh-7.5 h-7.5 text-#191D26 break-all">
            {bindInfo?.title}
          </div>
          {bindInfo?.content?.map((item, index) => (
            <div
              key={index}
              className="mt-0.5 text-3.5 lh-6 h-6 text-mx-tertiary"
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
